import { useDispatch } from 'react-redux';
import * as actions from '@actions';
import { useSessionAppointmentId } from '@hooks/useSessionAppointmentId';
import { useCancelledAppointments } from '@hooks/useCancelledAppointments';
import { useQuery } from '@tanstack/react-query';
import * as actionTypes from '@actionTypes';

// eslint-disable-next-line
type ProtectionDataType = {
  name: string;
  dob: Date;
  postcode: string;
  email: string;
  tel_mobile_no: string;
  tel_other_no: string;
  dpa_check_by: string;
  dpa_check_state: number;
  dpa_check_date: Date;
};

export enum ProtectionStatus {
  Failed = -1,
  Recognised = 0,
  Succeeded = 1,
  NoResponse = 2
}

const useProtectionData = () => {
  const dispatch = useDispatch();
  const appointment_id = useSessionAppointmentId(true);
  const { cancelledAppointments } = useCancelledAppointments();

  const { data: protectionData, refetch: refetchProtectionData } = useQuery({
    queryKey: ['protectionData', appointment_id],
    queryFn: async () => {
      const { type, payload } = await dispatch(actions.dataProtection(appointment_id));
      if (type === actionTypes.DATA_PROTECTION_SUCCESS) {
        return payload[0];
      }
      return undefined;
    },
    enabled: !cancelledAppointments?.[appointment_id]
  });

  return {
    protectionData,
    refetchProtectionData
  };
};

export { useProtectionData };
